var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.floatingErrors.length > 0
    ? _c(
        "div",
        {
          staticClass: "justify-content-center align-self-center",
          attrs: { id: "floating-container" }
        },
        [
          _c("p", { attrs: { "data-testid": "title-errors" } }, [
            _vm._v("You have "),
            _c(
              "span",
              { staticStyle: { color: "red", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.floatingErrors.length))]
            ),
            _vm._v(" invalid record(s). Please edit to continue")
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }